import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { ModuleState } from './types'

export const initialState: ModuleState = {
  posts: [],
  postsByTownByUserByStatus: {},
  postsByTownByUserPending: [],
  postsByTownByUserActive: [],
  postsByTownByUserInactive: [],
  postsByTownPending: []
}

export const state = initialState

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
